<div *ngIf="global_texts" class="all-content">
  <div class="">
    <app-header></app-header>
  </div>
  <div class="content">
    <div class="inner-content">

      <div class="sidebar-content">
        <app-sidebar></app-sidebar>
      </div>

      <div class="mt-5 mt-md-3 p-3 p-lg-5">
        <div class="d-flex">

          <div class="self-module">
            <!-- Import here the component account.complement -->
            <app-account></app-account>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
